(function () {
  var info = document.getElementById("contact_form__info");
  var messageRoot = document.getElementById("contact_form__message");
  var input = document.getElementById("contact_form__message__input");
  var submit = document.getElementById("contact_form__message__submit");
  var emptyNotice = document.getElementById("contact_form__message__notice__empty");

  if (!info || !messageRoot || !input || !submit || !emptyNotice) {
    return;
  }

  function updateMinHeight() {
    var infoHeight = info.getBoundingClientRect().height;
    var minHeight = Math.max(288, Math.round(infoHeight - 64));
    input.style.minHeight = minHeight + "px";
  }

  function queueHeightUpdates() {
    for (var i = 0; i < 10; i++) {
      (function (index) {
        window.setTimeout(updateMinHeight, index * 25);
      })(i);
    }
  }

  function updateSendState() {
    var hasValue = !!input.value.trim();
    submit.disabled = !hasValue;
    emptyNotice.style.display = hasValue ? "none" : "";
  }

  function sendMessage() {
    if (!input.value.trim()) {
      updateSendState();
      return;
    }

    input.disabled = true;
    messageRoot.classList.add("contact_form__message--processing");
    submit.disabled = true;

    window.setTimeout(function () {
      messageRoot.classList.remove("contact_form__message--processing");
      messageRoot.classList.add("contact_form__message--processed");
      input.value = " ";
    }, 3000);

    window.setTimeout(function () {
      input.value = "";
      input.disabled = false;
      messageRoot.classList.remove("contact_form__message--processed");
      updateSendState();
    }, 6000);
  }

  input.addEventListener("input", updateSendState);
  submit.addEventListener("click", sendMessage);
  window.addEventListener("resize", queueHeightUpdates, { passive: true });
  window.addEventListener("load", queueHeightUpdates);

  queueHeightUpdates();
  updateSendState();
})();
